// extracted by mini-css-extract-plugin
export default {"field-factory":"field-factory_field-factory__QziBI","remove-button":"field-factory_remove-button__BWA0F"};